import React, { memo } from 'react';
import type { TicketType } from '../../../../common/types';
import useGetGroupsByTicketType from '../../../../controllers/get-groups-by-ticket-type/index.tsx';
import Item from './item';

type Props = {
	ticketType: TicketType;
};

const ItemContainer = memo<Props>(({ ticketType }: Props) => {
	const { id, ...itemProps } = ticketType;
	const [groupIds, getGroupNames] = useGetGroupsByTicketType(id);

	return (
		<Item
			{...itemProps}
			groupCount={groupIds ? groupIds.length : 0}
			getGroupNames={getGroupNames}
		/>
	);
});

export default ItemContainer;
